import React from 'react';

import { ScreenHeaderTitle } from '../../common/screenHeader/ScreenHeaderTitle';
import { InformationPanel, TextParagraph } from '../../common/informationPanel/InformationPanel';

export const LoadingScreen = () => {
  const waitingForResponsePanelText: TextParagraph[] = [
    {
      text: 'This normally takes around 1 minute.',
      lineBreak: true,
    },
    {
      text: 'If it takes more than 3 minutes, something may have gone wrong. The process will time out and show any results received.',
      lineBreak: true,
    },
  ];

  return (
    <>
      {/* TODO add loading spinner here */}
      <ScreenHeaderTitle title={'Checking devices on site...'} />
      <InformationPanel
        title={null}
        textArray={waitingForResponsePanelText}
        background={false}
        textAlign={'center'}
        dataTestId={'info-panel-loading'}
      />
    </>
  );
};
